import axios from "axios";
import { BASE_URL } from "./api";

// CREATE A NEW VARIANT
export const createNewVariant = async (token, data) =>
  await axios.post(`${BASE_URL}/variants`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// GET ALL THE VARIANT
export const allVariants = async (token) =>
  await axios.get(`${BASE_URL}/variants`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// GET ALL THE VARIANTS BY PRODUCT
export const allVariantsByProduct = async (token, productId) =>
  await axios.get(`${BASE_URL}/variants/byProduct/${productId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// UPDATE A VARIANT
export const updateVariant = async (token, data, variantId) =>
  await axios.put(`${BASE_URL}/variants/${variantId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// DELETE THE VARIANT
export const deleteVariant = async (token, variantId) => {
  await axios.delete(`${BASE_URL}/variants/${variantId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// GET SINGLE THE VARIANT
export const singleVariant = async (token, variantId) =>
  await axios.get(`${BASE_URL}/variants/${variantId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// // ---SEARCH RESULTS---
// export const searchListings = async (query) =>
//   await axios.post(`${BASE_URL}/search-listings`, query);

export const filtersBySubcategory = async (token, subCategoryId) =>
  await axios.get(`${BASE_URL}/products/bySubCatId/${subCategoryId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
